import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SingleViewStateRecord } from '@src/suite/common/data-models/records/single-viewstate-record';
import { selectGroupSort, selectPSTGroupPrivileges } from '@src/suite/common/store/global-tables/global-tables.selectors';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { selectCurrentViewState } from '@src/suite/common/store/navigation/selectors/viewstate.selectors';
import { selectTopicsWithAssignmentsAndStories } from '@src/suite/common/store/records/records.selectors';
import { getGroupByOptions, getLayoutOptions, getSortByOptions } from '@src/suite/common/utils/viewstate-utils';

import { ListState } from './list.models';

const selectListState = createFeatureSelector<ListState>('list');

export const selectListGuids = createSelector(selectListState, state => state?.listGuids || []);

export const selectListNewGuids = createSelector(selectListState, state => state?.listNewGuids || []);

export const selectListNewTopics = createSelector(selectListNewGuids, selectTopicsWithAssignmentsAndStories, (listGuids, topics) => {
    return listGuids
        .map(guid => {
            return topics.get(guid) || null;
        })
        .filter(topic => !!topic);
});

export const selectLayoutOptions = createSelector(selectI18N, selectCurrentViewState, selectPSTGroupPrivileges, (i18n, currentViewState, PSTGroup) => {
    if (!currentViewState) return null;
    return getLayoutOptions(currentViewState?.viewStateType, i18n, PSTGroup);
});

export const selectGroupByOptions = createSelector(selectCurrentViewState, selectGroupSort, selectI18N, (viewState, groupSort, i18n) => {
    if (!viewState) return null;
    const options = getGroupByOptions(viewState.viewStateType, groupSort, i18n);
    if (viewState instanceof SingleViewStateRecord) {
        options.Value = viewState.viewStateGrouping.Value;
    }
    return options;
});

export const selectSortByOptions = createSelector(selectCurrentViewState, selectGroupSort, selectI18N, (viewState, groupSort, i18n) => {
    if (!viewState) return null;
    const options = getSortByOptions(viewState.viewStateType, groupSort, i18n);
    if (viewState instanceof SingleViewStateRecord) {
        options.Value = viewState.viewStateSorting.Value;
    }
    return options;
});

export const selectCurrentNodeUuid = createSelector(selectListState, state => {
    return state.selectedNodeUuid;
});
export const selectNodeExpandState = createSelector(selectListState, state => state.nodesExpandState);
export const selectListIsLoading = createSelector(selectListState, state => state.isLoading);
